// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__ZwXHi","LogoFull":"Logo_LogoFull__r8s5l"};